module.exports = __webpack_public_path__ + "static/media/pedidosOnline.c072bd1a.svg";